// Segmentos de rota que NÃO fazem parte da visualização do Cartivia.
//
// `administrador`/`admin`/`new-user-adm` são o ambiente administrativo do super-admin (a mesma
// noção do `adm === 'administrador'` do Top.tsx). `organizacao` é a tela de seleção de empresa:
// ali o usuário ainda não escolheu o tenant, então não há empresa a identificar no chat.
//
// ⚠️ Telas de admin DO TENANT (/configuracoes, /planilhas, /usuarios&permissoes) NÃO entram aqui:
// elas são Cartivia, e quem as usa é usuário do produto — é justamente quem mais precisa do
// suporte. "Modo administrativo" neste app é a área do super-admin, não "tela de configuração".
const SEGMENTOS_FORA_DO_CARTIVIA = [
  'administrador',
  'admin',
  'new-user-adm',
  'organizacao',
]

/**
 * A rota está fora da visualização do Cartivia? A regra é por **prefixo** de segmento (`adm-*`),
 * e não por lista fixa de rotas, para que uma tela `/adm-*` nova já nasça coberta — a lista fixa
 * de `Top.tsx` é a prova do problema: ela nunca recebeu `adm-gestao-tenants`.
 */
export const ehAreaAdministrativa = (pathname: string) =>
  pathname
    .split('/')
    .some(
      segmento =>
        segmento.startsWith('adm-') ||
        SEGMENTOS_FORA_DO_CARTIVIA.includes(segmento)
    )
